import i from "./_defineProperty.js";
var t = i;
function u(r, e, a) {
  e == "__proto__" && t ? t(r, e, {
    configurable: !0,
    enumerable: !0,
    value: a,
    writable: !0
  }) : r[e] = a;
}
var o = u;
export {
  o as default
};
//# sourceMappingURL=_baseAssignValue.js.map
